<template>
  <div class="main-card">
    <div class="card-container">
      {{ sliceStart }}{{ sliceEnd }}
      <div style="display: flex; gap: 10px;">
        <button
          style="border-radius: 50%; border: 1px solid #6d6d6d;"
          @click="previous"
          :disabled="button1State"
        >
          <img src="@/assets/timeslot-images/right1.svg" />
        </button>
        <button
          @click="next"
          style="border-radius: 50%; border: 1px solid #6d6d6d;"
          :disabled="button2State"
        >
          <img src="@/assets/timeslot-images/left.svg" />
        </button>
      </div>
      <div
        class="cards-sample"
        v-for="(item, index) in items.slice(sliceStart, sliceEnd)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestView",

  data() {
    return {
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      currentPage: 1,
      sliceStart: 0,
      itemsPerPage: 4,
      sliceEnd: 4,
      button1State: true,
      button2State: false
    };
  },
  methods: {
    next() {
      if (this.sliceEnd === this.items.length) {
        this.sliceStart = this.items.length - this.itemsPerPage;
      } else {
        this.sliceStart = this.sliceStart + 4;
        this.sliceEnd = this.sliceEnd + 4;
      }
    },
    previous() {
      if (this.sliceStart === 0) {
        this.sliceEnd = this.itemsPerPage;
      } else {
        this.sliceStart = this.sliceStart - 4;
        this.sliceEnd = this.sliceEnd - 4;
      }
    }
    //  Total items - no of items in the data list(12)
    //  itemsPerPage - no of items in a page(3)
    //  noOfPages - Total items/itemsPerPage(4)
    //  currentPage - page being viewed
    //  ifFirstPage - disable left button
    //  ifLastPage - disable right button
    //  previousPage  - currentPage - 1;
    //  lastPage  currentPage + 1;
  },
  watch: {
    sliceStart(newValue) {
      if (newValue === 0) {
        this.button1State = true;
      } else {
        this.button1State = false;
      }
    },
    sliceEnd(newValue) {
      if (
        newValue === this.items.length ||
        this.sliceStart === this.items.length ||
        this.sliceEnd > this.items.length
      ) {
        this.button2State = true;
      } else {
        this.button2State = false;
      }
    }
  }
};
</script>

<style scoped>
.main-card {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-container {
  border-radius: 8px;
  width: 300px;
  /*height: 300px;*/
  border: 1px solid #960505;
  padding: 20px;
  margin-top: 80px;
}
.cards-sample {
  border-radius: 10px;
  color: black;
  border: 1px solid #0098da;
}

button[disabled] {
  opacity: 0.5;
}
</style>
